export const Routes = {
  Home: '/',
  Login: '/login',
}
